import React from 'react';
import DataTable, { TableProps, TableColumn } from 'react-data-table-component';
import { ColumnStatus, ColumnImage, CustomLoader } from './Components';

import {
  primaryTheme,
  secondaryTheme,
  tertiaryTheme,
  primaryThemeWithMargin,
  secondaryWhithoutBorderTheme,
  secondaryThemeVoucher,
  supportTheme,
  producerTheme,
  childsEventsTheme,
} from './style';

type themeProps =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'primaryWithMargin'
  | 'support'
  | 'secondaryThemeVoucher'
  | 'childsEvents';

interface TablePropsCustom {
  theme?: themeProps;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface TableCustomProps extends TableProps<TablePropsCustom | any> {
  numberRowsPerPage: number;
  progressPending: boolean;
  expandableRows?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  expandableRowExpanded?: (row: any) => boolean;
  expandableRowsComponent?: React.ComponentType<any>;
  onRowExpandToggled?: (expanded: boolean, row: any) => void;
  expandableRowsHideExpander?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getRowId?: (row: any) => void;
}

const schemeTheme = {
  primary: primaryTheme,
  secondary: secondaryTheme,
  tertiary: tertiaryTheme,
  primaryWithMargin: primaryThemeWithMargin,
  secondaryWithoutBorder: secondaryWhithoutBorderTheme,
  support: supportTheme,
  secondaryThemeVoucher,
  producerTheme,
  childsEvents: childsEventsTheme,
};

export const CustomTable: React.FC<TableCustomProps> = ({
  theme = 'primary',
  data,
  progressPending,
  numberRowsPerPage,
  columns,
  expandableRows,
  expandableRowExpanded,
  expandableRowsComponent,
  onRowExpandToggled,
  expandableRowsHideExpander,
  getRowId,
  ...rest
}: TableCustomProps) => (
  <DataTable
    columns={columns}
    data={data}
    noDataComponent={'Sem dados para exibir'}
    progressPending={progressPending}
    progressComponent={<CustomLoader numberRowsPerPage={numberRowsPerPage} />}
    customStyles={schemeTheme[theme as themeProps] ?? schemeTheme.primary}
    expandableRows={expandableRows}
    expandableRowExpanded={expandableRowExpanded}
    expandableRowsComponent={expandableRowsComponent}
    onRowExpandToggled={onRowExpandToggled}
    expandableRowsHideExpander={expandableRowsHideExpander}
    onRowClicked={row => {
      // eslint-disable-next-line no-unused-expressions
      getRowId ? getRowId(row) : null;
    }}
    {...rest}
  />
);

export type { TableColumn };

export { ColumnStatus, ColumnImage };
